@if(preloader.loading()) {
<div class="fixed inset-0 z-[99999] grid place-items-center
            bg-white/70 dark:bg-black/60 backdrop-blur-[2px]">
  <div role="status" aria-live="polite" class="flex flex-col items-center gap-3">
    <div class="h-16 w-16 animate-spin rounded-full border-4 border-solid border-brand-500 border-t-transparent">
    </div>
    <span class="text-sm text-gray-600 dark:text-gray-300">Cargando…</span>
  </div>
</div>
}